/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Guardrails_Short_Item_3Inputs */



/**
* | output |
* | --- |
* | "False negatives (undetected content) may occur." |
*
* @param {Guardrails_Short_Item_3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const guardrails_short_item_3 = /** @type {((inputs?: Guardrails_Short_Item_3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Guardrails_Short_Item_3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("False Negatives (nicht erkannte Inhalte) können auftreten")
	return /** @type {LocalizedString} */ ("False negatives (undetected content) may occur.")
});